import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  height: 26px;
  background: ${(props) => props.theme.colors.surface_muted};
  border-radius: 6px;
  min-width: fit-content;
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
  color: ${(props) => props.theme.colors.text};

  p {
    font-size: 13px;
    text-align: right;
    color: ${(props) => props.theme.colors.text};
  }
`;

export default { Wrapper };
